/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_CPU_DETAILS_REQUEST,
  FETCH_CPU_DETAILS_SUCCESS,
  FETCH_CPU_DETAILS_FAILURE,
} from "./CpuDetailsTypes";

const initialState = {
  loading: false,
  architechures: [],
  error: "",
};

const cpuDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CPU_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_CPU_DETAILS_SUCCESS:
      return {
        loading: false,
        architechures: action.payload,
        error: "",
      };
    case FETCH_CPU_DETAILS_FAILURE:
      return {
        loading: false,
        architechures: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default cpuDetailsReducer;
